<app-header></app-header>
<div class="barra-flotante">
    <app-navbar></app-navbar>
</div>

<app-carrusel></app-carrusel>
<hr>
<app-servicios-lite></app-servicios-lite>
<app-contactanos-lite></app-contactanos-lite>
<app-footer></app-footer>